module.exports = __webpack_public_path__ + "images/content/plan_plus.png";